module.exports = __webpack_public_path__ + "static/img/ss2-4.2c76ad35.png";